import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';

import Bs4GenericField from './Bs4GenericField'
import Bs4MainDispatch from '../../Bs4MainDispatch'

export default class Bs4HTMLany extends Bs4GenericField {

  // getValue = () => {
  //   return  "<meta charset=\"UTF-8\">\n<title>Przykład ikony Font Awesome</title>\n<link rel=\"stylesheet\" href=\"https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css\">\n\n<div style=\"text-align: center;\">\n\n    <span style=\"color: #000033; font-size: 30px;\">200 zł</span>\n</div>"          
  // }
  
  setValueBs4(value) {
    this.setValue(value || '');
  }
  //hesValue () {return false;}
  
  ViewComponentField = (props) => {
    const formField = this;
    const [value, setValue] = React.useState(() => this.getValue());
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR)
    this.refFocus = React.useRef();

    const handleClick = (event) => {
      Bs4MainDispatch.commandParserAfter(this.bs4KartotekaId);
    }

    React.useEffect(() => {
      this.notValidElementDom = (text) => {setError({error: true, helperText: text})}
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        setValue(this.getValue());
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      })    
    }, [error]);
    
    return (
      <FormControl id={this.props.inputId} fullWidth error={error.error} >
        {!this.props.field.hideLabel ? <FormLabel><formField.Bs4Label/></FormLabel> : null}
        <div ref={this.refFocus} dangerouslySetInnerHTML={{__html:value}} onClick={handleClick}></div>
        <FormHelperText>{error.helperText}</FormHelperText>
      </FormControl>
    );
  }
}